// based on rc-cascader 0.16.2
import Cascader from './Cascader';
export default Cascader;
